<label *ngIf="!hideLabel">{{ label }}</label>
<button type="button" class="btn btn-outline-primary flex-fill btn-default-width form-control" [disabled]="isDisabled" (click)="switchState()">
  <fa-icon *ngIf="value" [icon]="icons.check" [fixedWidth]="true"></fa-icon>
  <span *ngIf="!value">&nbsp;</span>
</button>
<div class="form-text" *ngIf="description">{{ description }}</div>
